var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button",class:[{ 'disabled': _vm.disabled }, _vm.type ]},[_c('div',{staticClass:"copy"},[_vm._v(_vm._s(_vm.text))]),(_vm.icon)?_c('span',{staticClass:"icon mdi",class:_vm.icon}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }